import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Role } from "../../models/role";
import { Navigate, useParams } from 'react-router-dom';
import Wrapper from "../../components/Wrapper";
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import CountrySelect from '../../components/common/CountrySelect';
import { Col, Row } from 'react-bootstrap';

const UserEdit = (props: any) => {
    const [fullname, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [roleId, setRoleId] = useState('');
    const [roles, setRoles] = useState([]);
    const [redirect, setRedirect] = useState(false);
    const [phonecode, setPhonecode] = useState(0);
    const [mobile, setMobile] = useState('');
    const { id } = useParams();

    useEffect(() => {
        (
            async () => {
                const { data } = await axios.get(`users/${id}`);
                setFullName(data.full_name);
                setPhonecode(data.country);
                setMobile(data.mobile);
                setEmail(data.email);
                setRoleId(data.role.id);
                const response = await axios.get('roles');
                setRoles(response.data);
            }
        )()
    }, []);

    const submit = async (e: SyntheticEvent) => {
        e.preventDefault();
        try {
            await axios.put(`users/${id}`, {
                full_name: fullname,
                country: phonecode,
                mobile: mobile,
                email,
                role_id: roleId
            });
            setRedirect(true)
        } catch (error: any) {
            console.log(`${error.response.status}: ${error.response.message}`);
        }
    };

    if (redirect) {
        return <Navigate to={'/admin/users-list'} />
    }

    const handleCountrySelect = (selectedOption: any) => {
        if (selectedOption) {
            setPhonecode(selectedOption.id);
        } else {
            setPhonecode(0);
        }
    };

    return (
        <Wrapper>
            <div className='CardPedboxCover'>
                <div className='AdmintopTitleCov'>
                    <div className='AdmintopTitleLeft'>
                        <h1>Edit User</h1>
                    </div>
                    <div className='AdmintopTitleRight'></div>
                </div>
                <div className='FormCardMainbox'>
                    <form onSubmit={submit}>
                        <Row>
                            <Col md={6}>
                                <div className="InputMainComset">
                                    <label htmlFor="firstName" className="form-label">First Name</label>
                                    <input type="text" className="form-control" id="firstName"
                                        defaultValue={fullname}
                                        onChange={e => setFullName(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="InputMainComset" controlId="">
                                    <Form.Label>Country Code</Form.Label>
                                    <CountrySelect onSelect={handleCountrySelect} selectedCountryId={phonecode} className="mb-2" />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="InputMainComset" controlId="">
                                    <Form.Label>Mobile Number</Form.Label>
                                    <Form.Control type="text" placeholder="Enter your Mobile Number" autoComplete='false'
                                        defaultValue={mobile}
                                        onChange={e => setMobile(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <div className="InputMainComset">
                                    <label htmlFor="emailId" className="form-label">Email address</label>
                                    <input type="email" className="form-control" id="emailId"
                                        defaultValue={email}
                                        onChange={e => setEmail(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <label htmlFor="role" className="form-label">Role</label>
                                <select className="form-select" id="role"
                                    value={roleId}
                                    onChange={e => setRoleId(e.target.value)}>
                                    {roles.map((r: Role) => {
                                        return (
                                            <option key={r.id} value={r.id}>{r.name}</option>
                                        )
                                    })}
                                </select>
                            </Col>
                            <Col md={12}>
                                <button className="btn btn-outline-secondary">Save</button>
                            </Col>
                        </Row>
                    </form>
                </div>
            </div>
        </Wrapper>
    );
};

export default UserEdit;